export enum ProcessStatus {
  resolved = 'resolved',
  rejected = 'rejected',
}
